import React, { useState } from "react";
import { CarouselItem } from "./CarouselItem";
import "./Carousel.css";
import { transduction, transformation, conjugation } from "../../../assets";

export const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    {
      title: "Conjugation",
      description:
        "Genetic recombination in which there is a transfer of DNA from a living donor bacterium to a living recipient bacterium by cell-to-cell contact. In Gram-negative bacteria it typically involves a conjugation or sex pilus.Conjugation is encoded by plasmids or transposons. It involves a donor bacterium that contains a conjugative plasmid and a recipient cell that does not. A conjugative plasmid is self-transmissible, in that it possesses all the necessary genes for that plasmid to transmit itself to another bacterium by conjugation.",
      icon: conjugation,
    },
    {
      title: "Transformation",
      description:
        "Transformation is a form of genetic recombination in which a DNA fragment from a dead, degraded bacterium enters a competent recipient bacterium and is exchanged for a piece of the recipient’s DNA. This process usually only involves homologous recombination, a recombination of homologous DNA regions having nearly the same nucleotide sequences. In most cases, transformation occurs between related bacterial strains or strains of the same bacterial species, as the genetic material needs to be sufficiently similar for successful integration and recombination to take place.",
      icon: transformation,
    },
    {
      title: "Transduction",
      description:
        "Transduction involves the transfer of a DNA fragment from one bacterium to another by a bacteriophage.",
      icon: transduction,
    },
  ];

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = items.length - 1;
    } else if (newIndex >= items.length) {
      newIndex = 0;
    }
    setActiveIndex(newIndex);
  };
  return (
    <div className="carousel">
      <div
        className="inner"
        style={{ transform: `translate(-${activeIndex * 100}%)` }}
      >
        {items.map((item) => {
          return <CarouselItem item={item} width={"100%"} />;
        })}
      </div>
      <div className="carousel-buttons">
        <button
          className="button-arrowHG"
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
        >
          &lt;
        </button>
        <div className="indicators">
          {items.map((item, index) => {
            return (
              <button
                className="indicator-buttons"
                onClick={() => {
                  updateIndex(index);
                }}
              >
                <span
                  className={`material-symbols-outlined ${
                    index === activeIndex
                      ? "indicator-symbol-active"
                      : "indicator-symbol"
                  }`}
                >
                  ●
                </span>
              </button>
            );
          })}
        </div>
        <button
          className="button-arrowHG"
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Carousel;
